import {LABEL_KEY} from '../../../model/label-key.model';
import {LabelTranslator} from '../../../model/label-translator.model';
import {EmailBlock} from './email-block.model';
import {EMAIL_BLOCK_TYPE} from './email-block-type.model';
import {EmailBlockCard} from './email-block-card.model';
import {EMAIL_DEFAULT_BG_COLOR} from './email-default-bg-color.model';
import {EMAIL_DEFAULT_IMAGE_SIZE} from './email-default-image-size.model';

/** Livrée du bouton de collecte : celle du gabarit du serveur, pour que les deux s'accordent. */
const BUTTON_COLOR = '#4436FF';

/** Réseaux proposés d'emblée par un bloc « Social » : l'utilisateur y met ses propres adresses. */
const DEFAULT_SOCIAL_LINKS = [
    {url: 'https://facebook.com', icon: 'facebook', name: 'Facebook'},
    {url: 'https://twitter.com', icon: 'twitter', name: 'Twitter'},
];

/** Libellé du bouton de collecte, tel que le gabarit du serveur le nomme. */
const BUTTON_LABEL_KEY = 'media_email_template_btn_participate';

/**
 * Bloc vierge du type demandé, tel que la palette le dépose dans une colonne.
 *
 * Le libellé du bouton est celui du gabarit, traduit ici même : le contenu de l'e-mail ne porte que
 * du texte — les clés du serveur y sont remplacées au dépôt du média, une fois pour toutes
 * (cf. `MediaEmail.withTranslatedTexts`). Un bloc déposé plus tard n'étant plus relu, y laisser une
 * clé la ferait lire telle quelle, dans le canevas comme dans l'e-mail envoyé.
 */
export const buildEmailBlock = (type: EmailBlockCard['type'], translate: LabelTranslator): EmailBlock => {
    switch (type) {
        case EMAIL_BLOCK_TYPE.IMAGE:
            return {type, options: {...EMAIL_DEFAULT_IMAGE_SIZE, textAlign: 'left'}};

        case EMAIL_BLOCK_TYPE.TEXT:
            return {type, options: {text: {[LABEL_KEY]: ''}}};

        case EMAIL_BLOCK_TYPE.BUTTON:
            return {
                type,
                options: {
                    text: {[LABEL_KEY]: translate(BUTTON_LABEL_KEY)},
                    url: '{{collectUrl}}',
                    bgColor: BUTTON_COLOR,
                    color: EMAIL_DEFAULT_BG_COLOR,
                    borderColor: BUTTON_COLOR,
                    borderRadius: 8,
                    height: 0,
                    width: '100',
                    style: 'solid',
                    textAlign: 'center',
                },
            };

        case EMAIL_BLOCK_TYPE.SPACER:
            return {type, options: {height: 20}};

        case EMAIL_BLOCK_TYPE.DIVIDER:
            return {type, options: {bgColor: '#333333', width: '100', height: '1', style: 'solid'}};

        case EMAIL_BLOCK_TYPE.SOCIALS:
            return {type, options: {elements: DEFAULT_SOCIAL_LINKS.map((link) => ({...link}))}};
    }
};
